var stringify = require("./json-stringify-safe");
var radioStatus = false;

var utils = require("./utils");
var GOVUK = window.GOVUK;

/**
 * A facet listener that on change broadcasts its model.
 */
$.fn.facet = function () {
  return this.each(function () {
    var $self = $(this);
    var $controller = $self.hasClass(".govuk-main-wrapper")
      ? $self
      : $self.closest(".govuk-main-wrapper");

    var $showAllFacets = $controller.find(".show-filters");
    var $activeFacetsList = $self
      .siblings(".active-filters:first")
      .find(".active-filters-list");
    var $expandFacet = $self.find(".js-expander-handle");

    /**
     * Manage state within this object.
     * Note: This object should not be supplied via events, instead a copy
     * should be made to ensure that the object reference is broken.
     * @type {Object}
     * @private
     */
    var _state = {
      id: undefined,
      type: undefined,
      model: [],
      activeFacet: true,
      originalSelection: [],
    };

    // ------------------------------
    // Private methods
    // ------------------------------

    var _onChangeHandler = {
      checkbox: function (event) {
        if (_shouldUpdateFacetModel(event)) {
          var $target = $(event.target);

          _updateFacetModel($target, "checkbox");

          _broadcastChange();
        }
      },

      date: function (event) {
        if (_shouldUpdateFacetModel(event)) {
          var $target = $(event.target);

          _updateFacetModel($target, "date");

          _broadcastChange();
        }
      },

      deltaDate: function () {
        var $picker = $self.find("delta-date-picker");
        var $input = $picker.find("input[type=hidden]");
        var valid = $picker.find(".js-datepicker-date")[0].checkValidity();
        var value = valid ? $input.val() : "";
        var current = _getModelItemById($input.attr("name"));
        if (!current || current.value !== value) {
          _setModelItem($input.attr("name"), $picker.attr("label"), value, $input, false);
          _broadcastChange();
        }
      },

      datePicker: function (event) {
        let $datePicker = $(event.target).closest(".delta-date-picker");
        if ($datePicker.length == 0) {
          $datePicker = $(event.target).find(".delta-date-picker");
        }

        let day = $datePicker.find(".js-datepicker-date").val();
        let month = $datePicker.find(".js-datepicker-month").val();
        let year = $datePicker.find(".js-datepicker-year").val();

        let $datePickerInput = $datePicker.find(".date-picker_selected-date-input");

        if($datePickerInput.attr("valid") == "false") {
          return;
        }
        if (day && month && year) {
          let fullDate = new Date(`${year}-${month}-${day}`);
          fullDate.setHours(23);
          let formattedDate = fullDate.toISOString().split("T")[0];
          $self.find(".selected-date-window").val(formattedDate);

          _updateFacetModel($datePickerInput, "datePicker");
          _broadcastChange();
        } else if (!day && !month && !year) {
          $self.find(".selected-date-window").val("");
          _updateFacetModel($datePickerInput, "datePicker");
          _broadcastChange();
        }
      },

      radio: function (event) {
        if (_shouldUpdateFacetModel(event)) {
          var $target = $(event.target);

          _updateFacetModel($target, "radio");

          _broadcastChange();
        }
      },

      text: function (event) {
        if (_shouldUpdateFacetModel(event)) {
          var $target = $(event.target);

          var name = $target.attr("name");

          if (name !== undefined) {
            _updateFacetModel($target, "text");

            _broadcastChange();
          }
        }
      },

      tag: function (event) {
        if (_shouldUpdateFacetModel(event)) {
          var $target = $(event.target);

          var name = $target.attr("name");

          if (name !== undefined) {
            if (!$.isEmptyObject($target.data("update-to"))) {
              // This variable will be used to stall reloading the datagrid
              // till it hits zero. It will be stored in 'sessionStorage'
              // See dataGrid.js event, "dclg.dataGrid.triggerReload"
              // var staller = 1;

              _processUpdateToElements($target).done(function (processed) {
                $.each(processed, function (i, target) {
                  // Redefine params, since it's currently an two-layered object
                  i = Object.keys(target)[0];
                  target = target[i];

                  // 1. Clear any remnants of dynamically-added 'form-groups' from the facet
                  // 2. Update the facet model
                  // 3. Inject the new searchable-fields
                  if (target.endpoint == "searchable-fields") {
                    // Empty the inputfields and trigger the model update, as new data is coming in...
                    target.$facet
                      .find("input[type=text].form-control")
                      .val("")
                      .each(function () {
                        _updateFacetModel($(this), "text");
                      });

                    // // Notify the controller of the recent model update
                    // _broadcastChange();

                    // _updateFacetModel
                    // target.$facet.find('.searchable-fields-button:first').trigger('click');

                    // Inject new fields corresponding to the new incoming data...
                    _injectSF(target.$element, target.processedOptions);
                  } else {
                    // Simply trigger the 'change' event, which will update the facet model
                    // and notify the $controller
                    // target.$element.trigger('change');
                    _updateFacetModel(target.$element, "tag");
                  }
                });

                // When the 'update-to' elements have all been processed,
                // now process the initial element
                _updateFacetModel($target, "tag");
                _broadcastChange();
              });
            } else {
              _updateFacetModel($target, "tag");
              _broadcastChange();
            }
          }
        }
      },
    };

    function _updateFacetModel($target, facetType) {
      var boundItem = false;

      switch (facetType) {
        case "checkbox":
          _setModelItem(
            $target.attr("id"),
            $target.siblings(".govuk-label").text().trim(),
            $target.is(":checked"),
            $target,
            boundItem,
          );
          break;
        case "radio":
          var $targ;

          if (radioStatus) {
            $targ = $target[0];
            _setModelItem(
              $($targ).attr("name"),
              $($targ).siblings(".govuk-label").text().trim(),
              $($targ).val(),
              $($targ),
              boundItem,
            );
          } else {
            _setModelItem(
              $target.attr("name"),
              $target.siblings(".govuk-label").text().trim(),
              $target.val(),
              $target,
              boundItem,
            );
          }
          break;
        case "tag":
          if (!$.isEmptyObject($target.data("update-to"))) {
            boundItem = true;
          }
          const useText = $target.data("use-text");
          var selectedOptions = $target.val();
          selectedOptions = !$.isEmptyObject(selectedOptions)
            ? $.isArray(selectedOptions)
              ? selectedOptions.join(", ")
              : useText ? $target.find("option:selected").text() : selectedOptions
            : "";
          _setModelItem(
            $target.attr("name"),
            $target.siblings("label").text().trim() + " " + selectedOptions,
            $target.val(),
            $target,
            boundItem,
          );
          break;
        case "date":
          _setModelItem(
            $target.attr("name"),
            $target.siblings("label").text().trim(),
            $target.val(),
            $target,
            boundItem,
          );
          break;
        case "deltaDate":
        case "datePicker":
          _setModelItem(
              $target.attr("name"),
              facetType === "deltaDate" ? $target.closest("delta-date-picker").attr("label") : $target.attr("name"),
              $target.val(),
              $target,
              boundItem,
          );
          break;
        case "text":
          _setModelItem(
            $target.attr("name"),
            $target.siblings("label").text().trim() + " " + $target.val(),
            $target.val(),
            $target,
            boundItem,
          );
          break;
        default:
          break;
      }
    }

    function _resetPreloadedOptions($options) {
      // Alter attributes
      $options.removeAttr("selected");
      if ($options.data("target-fieldvalue")) {
        $options
          .data("target-fieldvalue", "")
          .attr("data-target-fieldvalue", "");
      }
    }

    function _updateSelectElemWithPreloadedView($options) {
      // Bring back into view
      $options
        .parent("select")
        .val($options.map(_getOptionValues).get())
        .trigger("chosen:updated");
    }

    function _handlePreloadedFacet() {
      if ($self.data("facet-preloaded")) {
        var $target,
          config = {};

        if (_isSearchableFieldFacet($self)) {
          $target = utils.fetchFacetsWithSetValues({
            facet: $self,
            type: "tag",
          });
        } else {
          if ($self.data("facet-type") == "deltaDate") {
            $target = $self.find("input[type=hidden]");
          }
          else if($self.data("facet-type") == "datePicker") {
            $target = $self.find(".selected-date-window");
          }
          else{
            $target = utils.fetchFacetsWithSetValues({ facet: $self });
          }
        }
        console.log(
          "*************************\n P R E L O A D E D: processing starts...\n**************************",
        );

        if ($.isEmptyObject($target)) {
          // // Simulate a click, to close the (presumably) expanded facet
          // $expandFacet.trigger('click');
        } else {
          // Expand facet
          $expandFacet.trigger("click");

          // Reveal entire facet list
          if (!$showAllFacets.data("is-expanded") && !$showAllFacets.data('force-closed')) {
            $showAllFacets.trigger("click");
          }

          config.$originalElement = $target;
          config.$facet = $self;
          config.isSearchableFieldFacet = _isSearchableFieldFacet($self);
          var $preloadedOptions;

          if ($target.hasClass("chosen-select") && $target.data("update-to")) {
            //DATASET

            _processUpdateToElements($target, true).done(function (processed) {
              $.each(processed, function (i, target) {
                // Redefine params, since it's currently an two-layered object
                i = Object.keys(target)[0];
                target = target[i];

                var preloadedOptions = target.preloadedOptions;

                // 1. Clear any remnants of dynamically-added 'form-groups' from the facet
                // 2. Update the facet model
                // 3. Inject the new searchable-fields
                if (target.endpoint == "searchable-fields") {
                  // // Empty the inputfields and trigger the model update, as new data is coming in...
                  // target.$facet.find('input[type=text].form-control').val('');
                  // target.$facet.find('.searchable-fields-button:first').trigger('click');

                  if (
                    target.$facet.find("input[type=text].form-control").length <
                    1
                  ) {
                    // Inject new fields corresponding to the new incoming data...
                    _injectSF(target.$element, target.processedOptions);
                  }
                }

                target.$element.val(preloadedOptions).trigger("chosen:updated");
                console.log(
                  "update-to: Preloaded values",
                  preloadedOptions,
                  "update-to: instance...",
                );
              });
            });
          } else if (config.isSearchableFieldFacet) {
            // SEARCHABLE-FIELDS

            $preloadedOptions = $target.children("option:selected");

            if (
              config.$facet.find("input[type=text].form-control").length < 1
            ) {
              // Dynamically inject searchable-fields
              _injectSF($target, $preloadedOptions.get());
            }

            // Trigger 'change' event to dynamically 'reveal' input[text] fields; i.e. SFs
            $target.trigger("chosen:updated").trigger("change");

            // Reformat $target to now refer to the input[text] fields,
            // since the $facet is currently defined as being a 'text' type
            $target = $self.find("input[type=text].form-control");

            config.$newElement = $target;

          } else if ($target.hasClass("chosen-select")) {
            // Any TAG facet
            $preloadedOptions = $target.children("option:selected");

            _resetPreloadedOptions($preloadedOptions);
            _updateSelectElemWithPreloadedView($preloadedOptions);
          } else {
            // Any other kind of facet...
          }

          // Update the model of each preloaded field
          $target.each(function () {
            _updateFacetModel($(this), $self.data("facet-type"));
          });

          // Update 'preloaded-facet' state
          $self
            .data("facet-preloaded", false)
            .attr("data-facet-preloaded", false);

          _state.initialModel = [];
          // Deep clone _state.model into _state.initialModel
          for (let i = 0; i < _state.model.length; i++) {
            _state.initialModel.push($.extend({}, _state.model[i]));
            if (Array.isArray(_state.initialModel[i].value)) {
              _state.initialModel[i].value = _state.initialModel[i].value.slice();
            }
          }

          // Broadcast the recent updates
          _broadcastChange(true);
        }
      }
    }

    function _setFacetValueToInitial() {
      if (!_state.initialModel) {
        return;
      }
      switch (_state.type) {
        case "deltaDate":
          const model = _state.initialModel[0];
          if (model) {
            _setDeltaDateValue(model.$element.closest("delta-date-picker"), model.value);
            _updateFacetModel(model.$element, "deltaDate");
          }
          break;
        case "tag":
          for (let i = 0; i < _state.initialModel.length; i++) {
            const model = _state.initialModel[i];
            model.$element.val(model.value).trigger("chosen:updated");
            model.$element.trigger("change");
          }
        case "checkbox":
          for (let i = 0; i < _state.initialModel.length; i++) {
            const checkbox = _state.initialModel[i];
            checkbox.$element.val(checkbox.value);
            checkbox.$element.prop("checked", checkbox.value);
            _updateFacetModel(checkbox.$element, "checkbox");
          }
        default:
        // handle other types of preloaded filters as required
      }
    }

    function _isSearchableFieldFacet($facet) {
      return (
        _state.id.toLowerCase() == "searchable_fields" &&
        $facet.find("select#searchableFields").length
      );
    }

    function _handleFacetVisibility(event, data) {
      var $facet = this.closest(".filter-selector");

      if (!data.childrenCount) {
        if ($facet.attr("data-facet-hidden")) {
          $facet.data("facet-hidden", true).attr("data-facet-hidden", true);
        } else {
          // Nothing for now
        }
      } else {
        // Reveal if formattedOptions available AND facet is still hidden
        // (also, assume that this runs only once. So, some DOM inits can go in here)
        if ($facet.data().facetHidden === true) {
          $facet.attr("data-facet-hidden", false);
        }
      }
    }

    /**
     * Replace the contents of a chosenjs selector
     * @param {jQuery} $element - jQuery object that contains the target select
     * @private
     */
    function _processUpdateToElements($element) {
      var updateTo = $element.data("update-to");
      var endpoint, request;
      var promises = [];

      var d = $.Deferred();

      for (endpoint in updateTo) {
        if (updateTo.hasOwnProperty(endpoint)) {
          // Return a Deferred object for each endpoint
          promises.push(
            _deferUpdateTo(
              $element,
              utils.copyObject(updateTo[endpoint]),
              endpoint,
            ),
          );
        }
      }

      // https://stackoverflow.com/questions/5627284/
      // - for passing an array to a function as comma-separated params
      $.when.apply($, promises).done(function () {
        var _processed = [];

        $.each(arguments, function () {
          var $targetElement,
            $facet,
            $preloadedOptions,
            optionsData,
            endpoint,
            formattedOptions,
            _request,
            self = {};

          optionsData = this;
          endpoint = Object.keys(optionsData)[0];
          _request = utils.copyObject(optionsData[endpoint].req);

          $targetElement = $("#" + _request.targetElementId);
          $facet = $targetElement.closest(".filter-selector");

          formattedOptions = _getOptionsArray(
            optionsData[endpoint].res,
            endpoint,
          );

          // hasPreloadedOptions
          $preloadedOptions = $targetElement.children("option:selected");

          // Empty
          $targetElement.empty();

          // Update with data
          $targetElement
            .append(stringifyOptions(formattedOptions).join(""))
            .trigger("chosen:updated");

          console.log(
            "R E S P O N S E: <option>s count",
            formattedOptions.length,
          );

          // Reveal FACET if its hidden AND formattedOptions were created
          if (endpoint == "searchable-fields" && formattedOptions.length) {
            $controller.trigger("dclg.facet.reveal", {
              childrenCount: formattedOptions.length,
            });
          }

          self[endpoint] = {
            $facet: $facet,
            $element: $targetElement,
            preloadedOptions: $preloadedOptions.map(_getOptionValues).get(),
            processedOptions: formattedOptions,
            endpoint: endpoint,
          };

          _processed.push(self);

          // d.resolve();

          // return d.promise();
        });

        d.resolve(_processed);
      });

      return d.promise();
    }

    function _deferUpdateTo($element, request, endpoint) {
      // replace the querystring with the new values.
      request.url =
        request.url.split("?")[0] +
        "?" +
        $element.attr("name") +
        "=" +
        $element.val();

      // cache endpoint identifier
      request.label = endpoint;

      return _fetchOptionsData(request);
    }

    function _getOptionValues() {
      if ($(this).is("option")) {
        return $(this).val();
      }
      return false;
    }

    function stringifyOptions(optionsArray) {
      if ($.isArray(optionsArray)) {
        return $.map(optionsArray, function (option) {
          if ($(option).is("option")) {
            return $(option).prop("outerHTML");
          }
        });
      }
    }

    function _fetchOptionsData(request) {
      var d = $.Deferred(),
        response = {};

      $.ajax({
        url: request.url,
        dataType: "json",
        type: "GET",
      }).done(function (res) {
        if (!$.isArray(res) && $.isPlainObject(res)) {
          // For client-side (localhost:3000) API testing, parse the locally-held
          // JSON to locate the block matching the selection sent...
          var queryString = request.url.substring(request.url.indexOf("?") + 1);
          res = res[queryString.split("=")[1]] || res["field"];
        }

        // Associate the AJAX response with the corresponding 'endpoint'
        response[request.label] = {};
        response[request.label].res = res;
        response[request.label].req = request;
        d.resolve(response);
      });

      return d.promise();
    }

    /**
     * Create and return an array of options
     * @param {Object[]} data[] - The text for each option
     * @return {Object[]} options[] - The options markup to add
     * @private
     */
    function _getOptionsArray(data, endpoint) {
      var options = [];


      if (!$.isEmptyObject(data)) {
        var field,
          fieldVal = "",
          fieldText = "",
          fieldName = "";

        for (var i = 0, dataLen = data.length; i < dataLen; i++) {
          if ($.isPlainObject(data[i])) {
            fieldText = data[i].label || data[i].name;

            fieldName = data[i].name || fieldText;

            fieldVal = "";

            field =
              '<option data-target-fieldname="' +
              fieldName +
              '" data-target-fieldvalue="' +
              fieldVal +
              '" value="' +
              fieldName +
              '">' +
              fieldText +
              "</option>";
          } else {
            fieldText = data[i];

            fieldVal = fieldText;

            field =
              '<option value="' + fieldVal + '">' + fieldText + "</option>";
          }
          field = $(field)[0];

          options.push(field);
        }
      }

      return options;
    }

    function _triggerSearchableFieldsModelUpdate(e) {
      e.preventDefault();

      var $sf,
        $facet = $(e.target).closest(".filter-selector");

      // Fetch the input fields, representing 'searchable fields'
      $sf = $facet.find("input[type=text].form-control");

      // Filter this facet to see if there are any fields with set values
      // console.log('sfWithValue', $sf);

      if ($sf.length) {
        // Update the facet model
        $sf.each(function () {
          _updateFacetModel($(this), "text");
        });

        // Notify the controller of the recent model update
        _broadcastChange();
      }
    }

    function _injectSF($injector, options) {
      var $injectorContainer = $injector.closest(".form-group");

      // CLear all .form-groups except the last (which should contain the Search button)
      $injectorContainer.siblings(".form-group:not(.form-group:last)").remove();

      // Inject fields - made hidden by default by the classname, .visually-hidden
      $.each(options, function (index, elem) {
        var $label = $("<label>")
          .text(elem.textContent)
          .attr("for", $(elem).data("target-fieldname"))
          .addClass("govuk-label");

        var $inputField = $('<input type="text">')
          .attr("name", $(elem).data("target-fieldname"))
          .attr("id", $(elem).data("target-fieldname"))
          .val($(elem).data("target-fieldvalue"))
          .addClass("form-control");

        $injectorContainer.after(
          $('<div class="form-group visually-hidden"></div>')
            .append($label)
            .append(" ")
            .append($inputField),
        );
      });
    }

    function _revealSF(e, chosenjsAction) {
      // onChange, selected 'options' should be revealed and the search-button made available for use

      var $target = $(e.target),
        $facet = $target.closest(".filter-selector"),
        $searchButton = $facet.find(".searchable-fields-button:first"),
        selectedOptions = $target.val(),
        dataCache = $target.data();

      if ($.isEmptyObject(chosenjsAction)) {
        if (selectedOptions.length) {
          $.each(selectedOptions, function () {
            $("#" + this)
              .closest(".form-group")
              .removeClass("visually-hidden");
          });
        } else {
          $facet.attr("data-facet-hidden", true);

          $facet
            .find("input[type=text].form-control")
            .val("")
            .closest(".form-group")
            .addClass("visually-hidden");
        }
      } else {
        if (chosenjsAction.deselected) {
          // Item deselected
          $target = $("#" + chosenjsAction.deselected);
          $target.val("");
          $target.closest(".form-group").addClass("visually-hidden");
        } else {
          // Item selected
          $target = $("#" + chosenjsAction.selected);
          $target.closest(".form-group").removeClass("visually-hidden");
        }
      }

      // ENABLE search button
      if (selectedOptions.length || dataCache.chosen["selected_option_count"]) {
        $searchButton.attr("disabled", false);
      } else {
        // Update the ActiveFAcet by simulating a click on the search button and then DISABLE the button

        $searchButton.trigger("click").attr("disabled", true);
      }
    }

    /**
     * Remove the selection in the DOM for supplied elements
     * @param {jQuery} $element
     * @private
     */
    function _removeSelectionOnElement(event, $element) {
      // Booleans, planned to be used for checking which event was triggered
      var isClearing = event.namespace == "clear.facets",
        isRemoving = event.namespace == "facets.remove";

      if (!$element.length) {
        console.log(
          "The element supplied does not match any of the expected field types",
        );
        return false;
      }

      if (_state.type === "deltaDate") {
        _setDeltaDateValue($self.find("delta-date-picker"), "");
      } else if (_isSearchableFieldFacet($self)) {
        if (isClearing) {
          // $element.is('select')

          // Empty and Clear the controlling element
          $element.empty();
          $element.val("").trigger("chosen:updated");

          // Remove the dynamically
          // injected text-fields a.k.a searchable-fields
          $element.closest(".form-group").siblings(".form-group").remove();
        } else if (isRemoving) {
          // $element.is('input[type=text]')
          var $select = $self.find("select#searchableFields");

          var updatedSelections = $.map($select.val(), function (value) {
            if (value !== $element.attr("name")) {
              return value;
            }
          });

          // Clear element
          $element.val("");

          // Update the element's original revealer/injector
          $select.val(updatedSelections).trigger("chosen:updated");
          $select.trigger("change", {
            deselected: $element.attr("name"),
          });
        }
      } else {
        if (_state.type === "checkbox" || _state.type === "radio") {
          // As we use GOVUK styled checkboxes we
          // must trigger an event deselection.
          $element.trigger("govuk.selection.clear");
        } else if (_state.type === "tag") {
          // 'Empty' any element which is a dependant
          $element.each(function () {
            if (
              $(this).data("updated-by") &&
              event.namespace == "clear.facets"
            ) {
              $(this).empty();
            }
          });

          // Clear any matching element/s
          $element.val("").trigger("chosen:updated");
        } else {
          $element.val("");
        }
      }
    }

    function _setDeltaDateValue($picker, value) {
      var parts = value.split("/");
      ["date", "month", "year"].forEach(function (part, index) {
        $picker.find(".js-datepicker-" + part).val(parts[index] || "");
      });
      $picker.find(".js-datepicker-year")[0]?.dispatchEvent(new Event("input"));
    }

    function _resetToInitialSelection(e) {
      _resetSelection(e, true)
    }

    function _clearSelection(e) {
      _resetSelection(e, false)
    }

    function _resetSelection(e, useInitialValues) {
      if (!sessionStorage.getItem("preloadedMonitor")) {
        // This variable will be used to stall reloading the datagrid
        // till it hits zero. It will be stored in 'sessionStorage'
        // See dataGrid.js event, "dclg.dataGrid.triggerReload"
        var staller = 0,
          REG = {};

        REG = JSON.parse(stringify(utils.getFacetRegistry()));

        staller = Object.keys(REG).length;
        sessionStorage.setItem("preloadedMonitor", staller); // Saving
      }

      var $selection;

      if (_isSearchableFieldFacet($self)) {
        $selection = $self.find("select.chosen-select");
      } else {
        $selection = $self.find("input").filter(function () {
          // Filter to return only those input fields which weren't generated
          // by the Chosen.js plugin

          return !$(this).parents(".chosen-container").length;
        });

        // As an alternative, if no 'input' fields were found,
        // try to see if there are 'select' fields.
        // This is due to the fact that those two elements are currently
        // the only types used in our 'facet' structure
        // Commented made: 30/01/2018 | By: @chiich
        if (!$selection.length) {
          $selection = $self.find("select.chosen-select");
        }
      }

      // else clear selection completely
      _removeSelectionOnElement(e, $selection);
      if ($selection[0].name == "summaryLevel") {
        $selection[0].checked = true;
        radioStatus = true;
        _updateFacetModel($selection, "radio");
      } else {
        _state.model = [];
      }

      if (useInitialValues) {
        _setFacetValueToInitial();
      }

      _broadcastChange();
    }

    function _shouldUpdateFacetModel(e) {
      var $element, shouldExclude;

      $element = $(e.target);

      if ($element && $element.closest("[data-is-excluded]").length) {
        shouldExclude =
          $element.closest("[data-is-excluded]").data("is-excluded") === true;
      }

      if (shouldExclude) {
        // Deselect those checkboxes which are out-of-view
        $self.find(".panel.js-hidden input:checkbox").each(function () {
          var $checkbox = $(this);

          var $filter = $activeFacetsList.find("li").filter(function () {
            return $(this).attr("data-facet-id") === $checkbox.attr("id");
          });
          $filter.find("a.remove-selected-facet").trigger("click");
        });

        return false;
      }

      if ($self.attr("data-stall-update") === "true") {
        return false;
      }

      return true;
    }

    /**
     * Remove the selection for a single facet.
     * @param event
     * @param {{ facetGroupId: String, facetId: String }} data
     * @private
     */
    function _removalHandler(event, data) {
      if (_state.id === data.facetGroupId) {
        _removeSelection(event, data);

        _broadcastChange();
      }
    }

    function _removeSelection(event, data) {
      _state.model.forEach(function (item) {
        if (item.id === data.facetId) {
          _removeSelectionOnElement(event, item.$element);
          item.value = false;
        }
      });
    }

    /**
     * Register the correct event listener
     * @private
     */
    function _registerListeners() {
      $self.on("change", _onChangeHandler[_state.type]);
      if (_state.type === "deltaDate") {
        $self.on("input", _onChangeHandler.deltaDate);
      }
      $self.on("dclg.facets.clear", _clearSelection);
      $self.on("dclg.facets.remove", _removalHandler);
      $self.on("dclg.facets.reset", _resetToInitialSelection);
      if(_state.type == "datePicker"){
        // Add listener to radio button for "any"
        const dateWindowFilter = $self.closest(".date-window-radio-filter");
        const anyRadioButton = dateWindowFilter.find(".date-window-any");
        anyRadioButton.on("click", function(event) {
          if(_state.model.length > 0) {
            // Clear selection on the hidden input
            const datePickerContainer = dateWindowFilter.find(".delta-date-picker-with-icon-button");
            //find and clear errors
            let errorMessages = datePickerContainer.find( ".govuk-date-input__errors .govuk-error-message");

            for(let i = 0; i < errorMessages.length; i++) {
                  let error = errorMessages[i];
                  if(!error.classList.contains("hidden")) {
                      error.classList.add("hidden");
                  }
            }

            datePickerContainer.find(".selected-date-window").value = "";
            const datePickerInputs = datePickerContainer.find(".govuk-date-input__input");

            datePickerInputs.each(function(index, input) {
              input.value = "";
            });
            $self.trigger("change", _onChangeHandler[_state.type]);
          }
        });
      }
    }

    /**
     * Broadcast an event on the $body element that controllers can hook into.
     * @private
     */
    function _broadcastChange(isInitialPageLoad) {
      // Create a copy of the internal state so the state cannot be modified
      var model = JSON.parse(stringify(_state))
      model.isInitialPageLoad = isInitialPageLoad
      $controller.trigger("dclg.facets.changed", model);
    }

    /**
     * Register a facet with the Controller, to accomodate facet-to-facet communication
     * @private
     */
    function _registerFacet() {
      // Create a copy of the internal state so the state cannot be modified
      utils.addFacetToRegistry(JSON.parse(stringify(_state)));
    }

    /**
     * Set the basic metadata describing a facet
     * @param {String} type
     * @param {String} fieldSetLabel
     * @private
     */
    function _setFacetMetadata(type, id) {
      const cleanId = id.replace(/\s|_/g, ''); // Removes spaces, underscores, and newlines
      _state.id = cleanId;
      _state.type = type;
      _state.model = [];
    }

    /**
     *
     * @param {string} id
     * @return {undefined|Object}
     * @private
     */
    function _getModelItemById(id) {
      for (var item in _state.model) {
        if (!_state.model.hasOwnProperty(item)) continue;
        if (_state.model[item].id == id) {
          return _state.model[item];
        }
      }

      return false;
    }

    /**
     * Update an existing item in the model (by reference),
     * or create a new item in the model.
     * @param {String} id
     * @param {String} label
     * @param {*} value
     * @param {jQuery} $element
     * @private
     */
    function _setModelItem(id, label, value, $element, bound) {
      var item;

      item = _getModelItemById(id);

      if (!item) {
        item = { id: id };
        _state.model.push(item);
      }

      item.label = label;
      item.value = value;
      item.$element = $element;
      item.bound = bound;
    }

    // ------------------------------
    // Initialisation
    // ------------------------------
    if ($self.data("facet-type")) {
      // the legend is used as the 'id' for the object.
      _setFacetMetadata($self.data("facet-type"), utils.generateFacetId($self));

      _registerListeners();

      _registerFacet();

      if (_isSearchableFieldFacet($self)) {
        var $target = $self.find("select#searchableFields"),
          $searchButton = $self.find(".searchable-fields-button:first");

        // Initialise 'change' event handler for searchable-fields
        $target.on("change", _revealSF);

        // Attach 'click' event for triggering a facet update
        $searchButton.on("click", _triggerSearchableFieldsModelUpdate);

        $controller.on(
          "dclg.facet.reveal",
          _handleFacetVisibility.bind($target),
        );
      }
      $(function () {
        // After page load, check to see if facet is preloaded
        _handlePreloadedFacet();
      });
    }
  });
};
